import React from "react";
import {
  List, Box, Typography, Input, Select, MenuItem, BottomNavigation, BottomNavigationAction, Button, TableContainer, Table, TableHead, TableBody, TableRow, Paper, Modal, Pagination, TextField,
  Menu, FormControl, FormControlLabel, RadioGroup, Radio, Snackbar, Alert
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import globalStyles from '../../utils/globalStyles';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    borderRadius: '0px !important'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding,
    borderRadius: '0px !important'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
function ProductExports() {
  const { handleSubmit, control, reset, getValues } = useForm({})
  const [allTableHeaders, setAllTableHeaders] = React.useState([
    { id: '_id', label: 'EcomId', checked: true },
    { id: 'oracleId', label: 'OracleId', checked: true },
    { id: 'name', label: 'Name', checked: true },
    { id: 'grandTotal', label: 'Brand', checked: true },
    { id: 'categories', label: 'Category', checked: true },
    { id: 'stock', label: 'Stock', checked: true },
    { id: 'invoicePrice', label: 'Invoice Price', checked: true },
    { id: 'createdAt', label: 'Created Date', checked: true },
    { id: 'status', label: 'Status', checked: true },
    { id: 'barcode', label: 'Barcode', checked: true },
    ,
  ])
  return (
    <>
      <Box sx={globalStyles.headerWrapperBox}>
        <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
          <Typography variant='h4'>Product Exports</Typography>
        </Box>
      </Box>
      <Box sx={globalStyles.headerWrapperBox}>

        <Box sx={{
          width: '100%',
          display: 'flex',
          margin: '0px 30px',

          // border: '1px solid black',
          '& .MuiInput-input': {
            width: '300px !important',
            padding: '5px 10px !important'
          },
          '& .MuiSvgIcon-root': {
            paddingRight: '10px'
          },
          //   '& .css-1ftyaf0-span':{
          //     // span :{
          //     visibility: 'visible !important'
          //   // }
          // },
          justifyContent: 'space-between'
        }}>
          <Box sx={{ width: '70%', display: 'flex', justifyContent: 'space-between' }}>
            <form>
              <Controller
                name='status'
                control={control}
                //rules={{ required: true}}
                render={({ field }) =>
                  <Select
                    label="Product"
                    id="demo-simple-select-disabled"
                    // labelId="demo-simple-select-disabled-label"
                    // multiple
                    // defaultValue={'Select Status'}
                    // value={selected}
                    // onChange={handleStatusFilter}
                    sx={{ border: '1px solid #2b3f7a', width: '150px' }}
                  >
                    <MenuItem value={1}>Enable</MenuItem>
                    <MenuItem value={2}>Disable</MenuItem>

                  </Select>
                }
                type='number'
              />
            </form>
            <form>
              <Controller
                name='status'
                control={control}
                //rules={{ required: true}}
                render={({ field }) =>
                  <Select
                    label="stock"
                    id="demo-simple-select-disabled"

                    // value={selected}
                    // onChange={handleStatusFilter}
                    sx={{ border: '1px solid #2b3f7a', width: '150px' }}
                  >
                    <MenuItem value={1}>In stock</MenuItem>
                    <MenuItem value={2}>Out of Stock</MenuItem>

                  </Select>
                }
                type='number'
              />
            </form>

            <form>
              <Controller
                name='Date'
                control={control}
                //rules={{ required: true}}
                render={({ field }) =>


                  <Select
                    label="Filter By Status"
                    id="demo-simple-select-disabled"
                    labelId="demo-simple-select-disabled-label"
                    // defaultValue={'Select Status'}
                    // onChange={handleDateFilter}
                    sx={{ border: '1px solid #2b3f7a', width: '200px' }}
                  >
                    <MenuItem value={1}>Today</MenuItem>
                    <MenuItem value={2}>Current Month</MenuItem>
                    <MenuItem value={3}>Last Month</MenuItem>
                    <MenuItem value={4}>3 Month</MenuItem>
                    <MenuItem value={5}>6 Month</MenuItem>
                    {/* <MenuItem value={6} onClick={() => setcustomDate(!customDate)}>Custom</MenuItem> */}
                  </Select>
                }
                type='number'
              />

            </form>

            <form>
              <Controller
                name='Date'
                control={control}
                //rules={{ required: true}}
                render={({ field }) =>


                  <Select
                    label="Filter By Status"
                    id="demo-simple-select-disabled"
                    labelId="demo-simple-select-disabled-label"
                    // defaultValue={'Select Status'}
                    // onChange={handleDateFilter}
                    sx={{ border: '1px solid #2b3f7a', width: '200px' }}
                  >

                    <div style={{ backgroundColor: 'white', width: '200px' ,margin:'0px',padding:'0px'}}>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ width: '40%',textAlign:'center' }}>
                          <label >SAR</label>
                          <input type="text" id="date" name='' style={{ width: '70%', height: '20px', padding: '5px', marginTop: '10px', marginLeft: "5px" }} />
                        </div>
                        <div style={{ marginTop:'37px' }}>
                          <span>to</span>
                        </div>
                        <div style={{ width: '40%',textAlign:'center'}}>
                          <label>SAR</label>
                          <input type="text" id="date" name='toDate' style={{ width: '70%', height: '20px', padding: '5px', marginTop: '10px', marginBottom: '10px', marginRight: "5px" }} />
                        </div>
                      </div>
                      </div>
                      <div style={{width:'200px', padding:'0px', }}>
                        <Button> ok</Button>
                      </div>
                
                  </Select>
                }
                type='number'
              />

            </form>

          </Box>
          <Box sx={{ width: '30%', justifyContent: "end", marginLeft: '10%' }}>
            <Box sx={{
              // width: '20vw',
              justifyContent: 'end',
              textAlign: 'end',
              '& .MuiButton-sizeSmall': {
                lineHeight: '30px !important'
              },
              '& .MuiDivider-root': {
                borderRightWidth: 'thin !important',
                borderColor: '#2b3f7a'
              }
            }}>

              <BottomNavigation
                showLabels
                sx={globalStyles.bottomNavigationMenu}>
                {/* <BottomNavigationAction label="Apply Filter" onClick={e => handleFiltersByStatus('status', e.target.value)} /> */}
                <BottomNavigationAction label="Export" />
              </BottomNavigation>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box>

        <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
          <Table aria-label="simple table">
            <TableHead sx={{
              backgroundColor: globalStyles.colors.backgroundPrimary,
              height: '40px !important',
              borderRadius: '0 !important',
              '& .MuiTableCell-root': {
                color: '#fff !important',
                padding: '10px !important',
                borderRight: '2px solid #fff !important',
                borderRadius: '0 !important'
              }
            }}>
              <TableRow>
                {allTableHeaders.map((header) => {
                  if (header.checked) {
                    return (
                      <StyledTableCell align='center'>{header.label}</StyledTableCell>
                    )
                  }
                })}

              </TableRow>
            </TableHead>
            <TableBody>
              <StyledTableRow >

                <StyledTableCell align='center'>5cd296303452c106a053d7d2</StyledTableCell>
                <StyledTableCell align='center'>17128101791770</StyledTableCell>
                <StyledTableCell align='center'>Min Maadan Alensan Excellence Bracelet from Value Bracelets Collection for Women</StyledTableCell>
                <StyledTableCell align='center'>Brand Name</StyledTableCell>
                <StyledTableCell align='center'>Category name</StyledTableCell>
                <StyledTableCell align='center'>In stock</StyledTableCell>
                <StyledTableCell align='center'>91</StyledTableCell>
                <StyledTableCell align='center'>2019-05-08</StyledTableCell>
                <StyledTableCell align='center'>true</StyledTableCell>
                <StyledTableCell align='center'>120200008887</StyledTableCell>

              </StyledTableRow>

            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box sx={{ justifyContent: 'center' }}>
        {/* <Pagination count={Math.ceil(totalCount / 50)} page={currentPage} onChange={handlePagination} /> */}
      </Box>

    </>
  )
}

export default ProductExports;